import { useCallback, useEffect } from 'react';
import { clearRolesAction, getRolesAction } from '../../redux/actions/rolesActions';
import { useDispatch, useSelector } from 'react-redux';

const useFetchRoles = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.roles.loading);

  const fetchRoles = useCallback(async () => {
    await dispatch(getRolesAction());
  }, [dispatch]);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  useEffect(() => {
    return () => {
      dispatch(clearRolesAction());
    };
  }, [dispatch]);

  return { loading };
};

export default useFetchRoles;
